var _templateObject = _taggedTemplateLiteralLoose(['\n\t@media (min-width: ', 'px) {\n\t\t', '\n\t}\n'], ['\n\t@media (min-width: ', 'px) {\n\t\t', '\n\t}\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import { css } from 'styled-components'; // Use a string to generate media query based on breakpoints keys

export var above = function above(label) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return function (_ref) {
      var theme = _ref.theme;
      return css(_templateObject, theme.griding.breakpoints[label].width, css.apply(undefined, args));
    };
  };
};
export default above;